const Error_404 = () => {

  return (
    <div className="h-screen bg-blanco relative  center">
      <div className="text-center bottom-36 mx-12 relative xsm:bottom-20 ">

        <h1 className="poppins-700 text-40 text-gris ">ERROR<br /><span className="text-60 ">404</span></h1>

        <p className="poppins-300 text-20 font-thin	">Lo sentimos.<br />
          No hemos podido encontrar la<br /> página que estabas buscando.</p></div>


      <div className="absolute bottom-0 fondo-404 center w-full h-40">
      </div>
    </div>


  )
}

export default Error_404;